import React from 'react';

import application from 'application';

import FontFamilySelector from './font-family-selector';

const STARTUP_FONT_FAMILY_VARIABLE = 'var(--startup-font-family)';

function resolveFontFamilyLabel(fontFamily) {

  if (!fontFamily) {
    return 'Font';
  }

  if (fontFamily === STARTUP_FONT_FAMILY_VARIABLE) {
    return application.getCurrentStartup().theme.fontFamily;
  }

  return fontFamily;

}

function FontFamilyButton(props) {

  const fontFamilyButtonAttributes = {
    className: 'inline-toolbar-button font-family-button',
    onClick: props.onToggle
  };

  const fontFamilyLabel = resolveFontFamilyLabel(props.fontFamily);

  function renderSelector() {

    if (props.displaySelector === false) {
      return;
    }

    const properties = {
      fontFamily: props.fontFamily,
      onChange(fontFamily) {
        props.onChange(fontFamily.value);
        props.onClose();
      }
    };

    return <FontFamilySelector {...properties} />;

  }

  return <div className="font-family-button-section">

    <button {...fontFamilyButtonAttributes}>
      <span className="font-family-button-label" style={{ fontFamily: props.fontFamily }}>{fontFamilyLabel}</span>
    </button>

    {renderSelector()}

  </div>;

}

export default FontFamilyButton;
